<template>
  <form style="position: relative">
    <div style="position:absolute; top: 10px; right: 10px;">
    <CopyBlock :sharedData="sharedData" />
    </div>
    <h2>{{ $t('Add.Divider.Divider') }} Block</h2>
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('main')">
        <span>{{ $t('Add.General.Main') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('main') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
      <div v-show="isSectionActive('main')" class="accordion-content">
      <NameProp :sharedData="sharedData" />
      <ClassNamesProp :sharedData="sharedData" />
      <div class="class-names">
          <span v-for="(name, index) in classNames" :key="index" class="class-pill">
            {{ name }}
          <span class="material-symbols-outlined class-remove" @click="removeClassName(index)">close</span>
          </span>
      </div>
      </div>
      </div>
    <div class="accordion-item">
    <div class="accordion-header" @click="toggleSection('style')">
        <span>{{ $t('Add.General.Style') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('style') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
    <div v-show="isSectionActive('style')" class="accordion-content">  
    <div class="divider">
      <label class="contentLabel" for="dividerColor">{{ $t('Add.Divider.DividerColor') }}</label>
      <div class="color-container">
        <input type="color" id="dividerColor" v-model="lineColor" />
        <span v-if="lineColor" class="material-symbols-outlined reset-color" @click="resetLineColor">refresh</span>
        <div v-else class="add-color-overlay">+</div>
      </div>
    </div>
    <div class="divider">
      <label class="contentLabel" for="lineHeight">{{ $t('Add.Divider.Height') }}</label>
      <div class="range-container">
        <input type="range" min="1" max="100" v-model="lineHeight" class="slider" id="lineHeight" />
        <span>{{ lineHeight }} px</span>
      </div>
    </div>
    </div>
    </div>
    <!-- Reiter: Positioning -->
    <div class="accordion-item">
      <div class="accordion-header" @click="toggleSection('positioning')">
        <span>{{ $t('Add.General.Positioning') }}</span>
        <span class="material-symbols-outlined">
          {{ isSectionActive('positioning') ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      </div>
    <div v-show="isSectionActive('positioning')" class="accordion-content">
    <PaddingProp :sharedData="sharedData" />
    </div>
    </div>
  </form>
</template>

<script>
import { isNameUnique } from '@/utils/isNameUnique';
import PaddingProp from './AddProps/PaddingProp.vue';
import NameProp from './AddProps/NameProp.vue';
import ClassNamesProp from './AddProps/ClassNamesProp.vue';
import CopyBlock from './AddProps/CopyBlock.vue';
export default {
  name: 'AddDivider',
  components: {
    NameProp,
    ClassNamesProp,
    PaddingProp,
    CopyBlock,
  },
  props: ['sharedData'],
  data(){
    return {activeSections: ['main'], 
    newClassName: '',
    isUniqueName: true,
    } // Default aktivierter Reiter}
  },
  computed: {
    lineColor: {
      get() {
        return this.sharedData?.data?.props?.lineColor || null;
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.lineColor = value;
      },
    },
    lineHeight: {
      get() {
        return this.sharedData?.data?.props?.lineHeight || 1;
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.lineHeight = value;
      },
    },
    activeSections: {
      get() {
        return this.sharedData?.data?.props?.activeSections || ['main'];
      },
      set(value) {
        if (!this.sharedData.data.props) this.sharedData.data.props = {};
        this.sharedData.data.props.activeSections = value;
      },
    },
  },
  methods: {
    toggleSection(section) {
      if (this.activeSections.includes(section)) {
        // Wenn der Abschnitt bereits geöffnet ist, entferne ihn
        this.activeSections = this.activeSections.filter(s => s !== section);
      } else {
        // Abschnitt hinzufügen
        this.activeSections.push(section);
      }
    },
    isSectionActive(section) {
      return this.activeSections.includes(section);
    },
    resetLineColor() {
      this.sharedData.data.props.lineColor = null;
    },
    addClassName() {
      const trimmedName = this.newClassName.trim();
      if (trimmedName && !this.classNames.includes(trimmedName)) {
        this.classNames = [...this.classNames, trimmedName];
      }
      this.newClassName = '';
      this.$store.dispatch('addClass', trimmedName);
    },
    removeClassName(index) {
      const classNameToRemove = this.classNames[index]
      this.$store.dispatch('removeClass', classNameToRemove);
      this.classNames = this.classNames.filter((_, i) => i !== index);
    },
  },
  mounted() {
    this.isUniqueName = isNameUnique(this.sharedData.data.props.name, this.sharedData.id);
  },
  watch: {
    'sharedData.data.props.name': function(newName) {
      this.isUniqueName = isNameUnique(newName, this.sharedData.id); // Name check
    }
  }
};
</script>


 <style scoped>
 @import '../../styles/addComponents.css';
 </style>